export default "e5038978ac5e5ecc.svg"